const config = {
  bucketName: "cdn.dentalproductshopper.com",
  region: "us-east-1",
  accessKeyId: "AKIA2NAXAWCWCZNTSL7M",
  secretAccessKey: "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",
};

export default config;
